// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/css/" + chunkId + "." + {"233":"23f8a39e","316":"3deab8d7","376":"2aeaba4b","606":"b524bb5a","721":"042d5da1","993":"e5dbb0a9"}[chunkId] + ".css";
};